module.exports = __webpack_public_path__ + "static/media/1600.b047055d.jpg";